export const login = {
    label: "ログイン",
    href: "#",
    target: "internal",
};

export const more = {
    label: "もっと",
    href: "#",
    target: "internal",
};
